/**
 * Resolves the CMS language id for proxied API calls (X-Language-Id).
 * Registered from app.js so we avoid a store ↔ ApiClient circular import.
 */
let resolver = () => {
    if (typeof localStorage === 'undefined') return null;
    return localStorage.getItem('langId');
};

export function setApiLanguageIdResolver(fn) {
    resolver = typeof fn === 'function' ? fn : resolver;
}

export function getApiLanguageId() {
    const id = resolver();
    if (id === undefined || id === null || id === '') return null;
    return id;
}
